module.exports = __webpack_public_path__ + "static/media/icone_upload.1820b212.svg";